<app-sort [id]="'sort'" [(sort)]="params['sort']" style="display: none;"></app-sort>
<h1 hidden>{{this.H1Title}}</h1>
<h2 hidden>{{this.H2Title}}</h2>
<ng-container *ngFor="let i of result">
    <h3 hidden *ngIf="params['type'] != 'specials'">{{i.VehicleMake | titlecase}} {{i.VehicleSeries}}</h3>
    <h3 hidden *ngIf="params['type'] == 'specials'">{{i.Caption}} - {{i.PriceText}}</h3>
</ng-container>
<h2 hidden>Why Choose {{this.metaFilters[0]?.sitename}}?</h2>
<h3 hidden>Trusted {{this.metaFilters[0]?.sitename}} Dealership Network</h3>
<h3 hidden>Comprehensive Warranty & Service Plans</h3>
<h2 hidden>Exclusive {{params['type']}} Car Deals</h2>
<h3 hidden *ngIf="params['type'] == 'specials'">Limited-Time Promotions</h3>
<ng-container *ngFor="let i of result">
    <h4 hidden *ngIf="params['type'] == 'specials'">{{i.Caption}} - {{i.PriceText}}</h4>
</ng-container>
<h2 hidden>Need Assistance?</h2>
<h3 hidden>Get Pre-Approved Finance</h3>
<h3 hidden>Book a Test Drive</h3>
<form [formGroup]="searchForm">
    <div id="main" class="row main">

        <div *ngIf="!this.hideSearchFilters" id="accordionFilters" class="accordion d-none d-md-block">

            <div class="col-12 ">
                {{((this.params['type']) || 'All') | titlecase}} Search Filters
                <!--<div *ngIf="this.params['type'] == 'specials'" class="accordion-item">
                    <h2 class="accordion-header" id="headingSpecialType">
                        <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                            data-bs-target="#collapseSpecialType" aria-expanded="false" aria-controls="collapseOne">
                            Special Type
                        </button>
                    </h2>
                    <div id="collapseSpecialType" class="accordion-collapse collapse" aria-labelledby="headingSpecialType"
                        data-bs-parent="#accordionFilters">
                        <div class="accordion-body">
                            <div class="selectbox">

                                <p>Special Type</p> <select [ngModel]="params['specialType']||'-1'"
                                    (change)="select('specialType',$event)" formControlName="specialType">
                                    <option value="-1" selected>All Specials</option>
                                    <option *ngFor="let specialType of this.SpecialsCategories" value="{{specialType.SpecialCategoryID_PK}}">
                                        {{specialType.Name}}</option>
                                </select>
                            </div>

                        </div>
                    </div>
                </div>-->
                <div class="accordion-item" *ngIf="!Truck">
                    <h2 class="accordion-header" id="headingMakes">
                        <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                            data-bs-target="#collapseMakes" aria-expanded="false" aria-controls="collapseOne">
                            <div *ngIf="(this.params['type'] != 'new' && this.params['type'] != 'commercials' && this.params['type'] != 'newstock') || this.Makes.length > 1">Makes &&nbsp;</div><div>Series</div>
                        </button>
                    </h2>
                    <div id="collapseMakes" class="accordion-collapse collapse" aria-labelledby="headingMakes"
                        data-bs-parent="#accordionFilters">
                        <div class="accordion-body">
                            <div *ngIf="(this.params['type'] != 'new' && this.params['type'] != 'commercials' && this.params['type'] != 'newstock') || this.Makes.length > 1" class="selectbox">

                                <p>Makes</p>
                                <select [ngModel]="params['make']||'-1'" (change)="makeselect($event)"
                                    formControlName="make">
                                    <option value="-1" selected>All Makes</option>
                                    <option *ngFor="let make of this.Makes" value="{{make.VehicleMakeID_PK}}">
                                        {{make.Name.toUpperCase()}}</option>
                                </select>
                            </div>
                            <div class="selectbox">

                                <p>Series</p>
                                <select  (change)="select('series',$event)"
                                    formControlName="series">

                                    <option value="-1" selected>All Series</option>
                                    <option *ngFor="let series of this.Series" value="{{series.VehicleSeriesID_PK || series.VehicleSeriesID_FK}}">
                                        {{series.Name.toUpperCase()}}</option>
                                </select>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="accordion-item" *ngIf="Truck">
                    <h2 class="accordion-header" id="headingSizes">
                        <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                            data-bs-target="#collapseSizes" aria-expanded="false" aria-controls="collapseOne">
                            Size
                        </button>
                    </h2>
                    <div id="collapseSizes" class="accordion-collapse collapse" aria-labelledby="headingSizes"
                        data-bs-parent="#accordionFilters">
                        <div class="accordion-body">
                            <div class="selectbox">
                                <p>Sizes</p>
                                <select [ngModel]="params['sizes']||''" (change)="select('sizes',$event)"
                                    formControlName="sizes">
                                    <option value="" selected>All Sizes</option>
                                    <option *ngFor="let sizes of this.Sizes" value="{{sizes.name}}">
                                        {{sizes.text}}</option>
                                </select>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="accordion-item" *ngIf="Truck">
                    <h2 class="accordion-header" id="headingRanges">
                        <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                            data-bs-target="#collapseRanges" aria-expanded="false" aria-controls="collapseOne">
                            Range
                        </button>
                    </h2>
                    <div id="collapseRanges" class="accordion-collapse collapse" aria-labelledby="headingRanges"
                        data-bs-parent="#accordionFilters">
                        <div class="accordion-body">
                            <div class="selectbox">
                                <p>Ranges</p>
                                <select [ngModel]="params['range']||''" (change)="select('range',$event)"
                                formControlName="range">
                                    <option value="" selected>All Ranges</option>
                                    <option *ngFor="let range of this.Range" value="{{range.name}}">
                                        {{range.text}}</option>
                                </select>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="accordion-item" *ngIf="this.params['type'] != 'new' && this.params['type'] != 'commercials' && this.params['type'] != 'newstock' && !this.params['type']?.includes('specials') && !Truck">
                    <h2 class="accordion-header" id="headingYears">
                        <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                            data-bs-target="#collapseYears" aria-expanded="false" aria-controls="collapseOne">
                            Year
                        </button>
                    </h2>
                    <div id="collapseYears" class="accordion-collapse collapse" aria-labelledby="headingYears"
                        data-bs-parent="#accordionFilters">
                        <div class="accordion-body">

                            <div class="selectbox">

                                <p>Year From</p>
                                <select [ngModel]="params['yearmin']||'-1'" (change)="select('yearmin',$event)"
                                    formControlName="yearmin">
                                    <option value="-1" selected>10+ Years Old</option>
                                    <option *ngFor="let year of this.ModelYears" value="{{year.ModelYear}}">
                                        {{year.ModelYear}}</option>
                                </select>
                            </div>
                            <div class="selectbox">

                                <p>Year To</p>
                                <select [ngModel]="params['yearmax']||'-1'" (change)="select('yearmax',$event)"
                                    formControlName="yearmax">
                                    <option value="-1" selected>Current Year</option>
                                    <option *ngFor="let year of this.ModelYears" value="{{year.ModelYear}}">
                                        {{year.ModelYear}}</option>
                                </select>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="accordion-item" *ngIf="!this.params['type']?.includes('specials') && !Truck">
                    <h2 class="accordion-header" id="headingPrice">
                        <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                            data-bs-target="#collapsePrice" aria-expanded="false" aria-controls="collapseOne">
                            Price
                        </button>
                    </h2>
                    <div id="collapsePrice" class="accordion-collapse collapse" aria-labelledby="headingPrice"
                        data-bs-parent="#accordionFilters">
                        <div class="accordion-body">
                            <div class="selectbox">

                                <p>From Price</p><input [ngModel]="params['pricemin']||undefined"
                                    (change)="select('pricemin',$event)" formControlName="pricemin" type="number"
                                    placeholder="{{this.currency}}0">
                            </div>

                            <div class="selectbox">

                                <p>To Price</p><input [ngModel]="params['pricemax']||undefined"
                                    (change)="select('pricemax',$event)" formControlName="pricemax" type="number"
                                    placeholder="{{this.currency}}1,000,000+">
                            </div>
                            <p>Installment from {{this.currency}}{{monthlyPayment(params['pricemin'])||0}} per month</p>
                        </div>
                    </div>
                </div>
                <div class="accordion-item" *ngIf="this.params['type'] != 'new' && this.params['type'] != 'commercials' && this.params['type'] != 'newstock' && !this.params['type']?.includes('specials') && !Truck">
                    <h2 class="accordion-header" id="headingKilometres">
                        <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                            data-bs-target="#collapseKilometres" aria-expanded="false" aria-controls="collapseOne">
                            Kilometre
                        </button>
                    </h2>
                    <div id="collapseKilometres" class="accordion-collapse collapse" aria-labelledby="headingKilometres"
                        data-bs-parent="#accordionFilters">
                        <div class="accordion-body">
                            <div class="selectbox">

                                <p>From Kilometre</p> <input [ngModel]="params['kilomin']||undefined"
                                    (change)="select('kilomin',$event)" formControlName="kilomin" type="number"
                                    placeholder="Min Kilometres">
                            </div>

                            <div class="selectbox">

                                <p>To Kilometre</p><input [ngModel]="params['kilomax']||undefined"
                                    (change)="select('kilomax',$event)" formControlName="kilomax" type="number"
                                    placeholder="Max Kilometres">
                            </div>
                        </div>
                    </div>
                </div>
                <div class="accordion-item" *ngIf="!Truck">
                    <h2 class="accordion-header" id="headingRegions">
                        <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                            data-bs-target="#collapseRegions" aria-expanded="false" aria-controls="collapseOne">
                            Region
                        </button>
                    </h2>
                    <div id="collapseRegions" class="accordion-collapse collapse" aria-labelledby="headingRegions"
                        data-bs-parent="#accordionFilters">
                        <div class="accordion-body">
                            <div class="selectbox">

                                <p>Region</p> <select [ngModel]="params['region']||'-1'"
                                    (change)="select('region',$event)" formControlName="region">
                                    <option value="-1" selected>All Regions</option>
                                    <option *ngFor="let region of this.Regions" value="{{region.RegionID_PK}}">
                                        {{region.Name}}</option>
                                </select>
                            </div>

                        </div>
                    </div>
                </div>
                <div class="accordion-item" *ngIf="!Truck">
                    <h2 class="accordion-header" id="headingDealers">
                        <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                            data-bs-target="#collapseDealers" aria-expanded="false" aria-controls="collapseDealers">
                            Dealership
                        </button>
                    </h2>
                    <div id="collapseDealers" class="accordion-collapse collapse" aria-labelledby="headingDealers"
                        data-bs-parent="#accordionFilters">
                        <div class="accordion-body">
                            <div class="selectbox">

                                <p>Dealership</p> <select [ngModel]="params['dealership']||'-1'"
                                    (change)="select('dealership',$event)" formControlName="dealership">
                                    <option value="-1" selected>All Dealerships</option>
                                    <optgroup *ngFor="let region of Regions" label="{{region.Name}}">
                                        <option *ngFor="let dealer of regionDealers(region.Name)"
                                            value="{{dealer.DealershipID_PK}}">
                                            {{dealer.Name}}</option>

                                    </optgroup>
                                </select>
                            </div>

                        </div>
                    </div>
                </div>
                
                <div class="accordion-item" *ngIf="!this.params['type']?.includes('specials')">
                    <h2 class="accordion-header" id="headingMore">
                        <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                            data-bs-target="#collapseMore" aria-expanded="false" aria-controls="collapseMore">
                            More
                        </button>
                    </h2>
                    <div id="collapseMore" class="accordion-collapse collapse" aria-labelledby="headingMore"
                        data-bs-parent="#accordionFilters">
                        <div class="accordion-body">
                            <div class="selectbox" *ngIf="!Truck">
                                <p>Fuel Type</p> <select [ngModel]="params['fueltype']||'-1'"
                                    (change)="select('fueltype',$event)" formControlName="fueltype">
                                    <option value="-1" selected>All Fuel Types</option>
                                    <option *ngFor="let fueltype of this.FuelTypes"
                                        value="{{fueltype.VehicleFuelTypeID_PK}}">{{fueltype.Name}}</option>
                                </select>
                            </div>
                            <div class="selectbox">
                                <p>Gear Type</p><select [ngModel]="params['geartype']||'-1'"
                                    (change)="select('geartype',$event)" formControlName="geartype">
                                    <option value="-1" selected>All Gear Types</option>
                                    <option *ngFor="let geartype of this.GearTypes"
                                        value="{{geartype.VehicleTransmissionID_PK}}">{{geartype.Name}}</option>
                                </select>
                            </div>
                            <div class="selectbox" *ngIf="!Truck && !hideBodyTypeFilter && this.BodyTypes.length > 1">
                                <p>Body Type</p> <select [ngModel]="params['bodytype']||'-1'"
                                    (change)="select('bodytype',$event)" formControlName="bodytype">
                                    <option value="-1" selected>All Body Types</option>
                                    <option *ngFor="let bodytype of this.BodyTypes"
                                        value="{{bodytype.VehicleTypeID_PK}}">
                                        {{bodytype.Name}}</option>
                                </select>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="accordion-item">
                    <h2 class="accordion-header" id="headingSort">
                        <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                            data-bs-target="#collapseSort" aria-expanded="false" aria-controls="collapseSort">
                            Sort by
                        </button>
                    </h2>
                    <div id="collapseSort" class="accordion-collapse collapse" aria-labelledby="headingSort"
                        data-bs-parent="#accordionFilters">
                        <div class="accordion-body">
                            <div class="selectbox">

                                <p>Sort By</p> <select [ngModel]="params['sort']" (change)="select('sort',$event)"
                                    formControlName="sort">
                                    <option *ngFor="let sort of this.Sorts" value="{{sort.Value}}">{{sort.Name}}
                                    </option>
                                </select>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
            <div>
                <button type="button" (click)="clear()" class="btn-secondary">Clear All Filters</button>
                <!--<button class="btn-secondary">Search</button>-->
                <button type="button" (click)="alert()" class="btn-primary">Vehicle Alerts</button>
                <input style="display:none" type="submit"/>
            </div>
        </div>
        <div class="mainpage" [ngClass]="this.hideSearchFilters ? 'hidesearchfilters' : ''">
            <div class="row nav" *ngIf="(Site && Dealerships && DealerCategoriesComplete && !HideTopNavButtons) && ((Site?.NumberOfSpecials > 0) || (Site?.NumberOfNewStock > 0) || (Site?.NumberOfUsedStock > 0) ||(Site?.NumberOfDemoStock > 0) || DealerCategories.Commercials)">
                <div class="col-12 col-md" *ngIf="!HideAllButton && this.Site" >
                    <button (click)="go('type','')"
                        [ngClass]="this.params['type'] == '' || this.params['type'] == null ?'btn-primary':'btn-secondary'">All</button>

                </div>
                <div class="col-6 col-md" *ngIf="DealerCategories.New && Site">

                    <button (click)="go('type','new')"
                        [ngClass]="this.params['type'] == 'new'?'btn-primary':'btn-secondary'">New</button>

                </div>
                <div class="col-6 col-md" *ngIf="DealerCategories.Used && Site && DealerCategoriesComplete && !HideDemo && Site?.NumberOfDemoStock > 0">

                    <button (click)="go('type','demo')"
                        [ngClass]="this.params['type'] == 'demo'?'btn-primary':'btn-secondary'">Demo</button>

                </div>
                <div class="col-6 col-md" *ngIf="DealerCategories.Used && Site && DealerCategoriesComplete && !HideUsed && Site?.NumberOfUsedStock > 0">

                    <button (click)="go('type','used')"
                        [ngClass]="this.params['type'] == 'used'?'btn-primary':'btn-secondary'">Used</button>

                </div>
                <div class="col-6 col-md" *ngIf="DealerCategories.Commercials == true && Site">

                    <button (click)="go('type','commercials')"
                        [ngClass]="this.params['type'] == 'commercials'?'btn-primary':'btn-secondary'">Commercials</button>

                </div>
                <div class="col-6 col-md" *ngIf="Site?.NumberOfNewStock > 0 && Site && !HideDealerStock">

                    <button (click)="go('type','newstock')"
                        [ngClass]="this.params['type'] == 'newstock'?'btn-primary':'btn-secondary'">Dealer New Stock</button>

                </div>
                <div class="col col-md" *ngIf="Site?.NumberOfSpecials > 0 && Site">

                    <button (click)="go('type','specials')"
                        [ngClass]="this.params['type'] && this.params['type'].includes('specials')?'btn-primary':'btn-secondary'">Specials</button>

                </div>
            </div>
            <div *ngIf="!this.hideSearchFilters" class="d-flex d-md-none filterrow row">


                <a class="filter" data-bs-toggle="offcanvas" href="#offcanvasFilters"><button class="btn-tertiary"><span
                            class="icon-sort"></span> Filters</button></a>

                <a class="filter" data-bs-toggle="offcanvas" href="#offcanvasSort"><button class="btn-tertiary">
                        <span class="icon-search"></span> Sort By</button></a>


            </div>
            <div *ngIf="this.params['type'] && params['type'].includes('specials')" class="row searchrow d-none d-md-block">
                <div class="col-12 hor">
                    <div class="text-center "><p class="heading">Special Type: </p></div>
                
                   <div class="text-center " *ngIf="!this.SpecialSelectionLayout" (click)="selectSpecialType('')" [ngClass]="selectedSpecialType('')?'selected':''"><span  class="icon-specialsall"></span><p>All</p></div>
                   <div *ngIf="specialTypeExists('New')" class="text-center " (click)="selectSpecialType('New')" [ngClass]="selectedSpecialType('New')?'selected':''"><span  class="icon-specialsnew"></span><p>New</p></div>
                    <div *ngIf="specialTypeExists('Pre-Owned')" class="text-center " (click)="selectSpecialType('Pre-Owned')" [ngClass]="selectedSpecialType('Pre-Owned')?'selected':''"><span  class="icon-specialsused"></span><p>Pre-Owned</p></div>
                    <div *ngIf="specialTypeExists('Demo')" class="text-center " (click)="selectSpecialType('Demo')" [ngClass]="selectedSpecialType('Demo')?'selected':''"><span  class="icon-specialsdemo"></span><p>Demo</p></div>
                    <div *ngIf="specialTypeExists('Service')" class="text-center " (click)="selectSpecialType('Service')" [ngClass]="selectedSpecialType('Service')?'selected':''"><span  class="icon-specialsservice"></span><p>Service</p></div>
                    <div *ngIf="specialTypeExists('Parts')" class="text-center " (click)="selectSpecialType('Parts')" [ngClass]="selectedSpecialType('Parts')?'selected':''"><span  class="icon-specialsparts"></span><p>Parts</p></div>
                    <div *ngIf="specialTypeExists('Other')" class="text-center " (click)="selectSpecialType('Other')" [ngClass]="selectedSpecialType('Other')?'selected':''"><span  class="icon-specialsother"></span><p>Other</p></div>
                  </div>
            </div>
            <div *ngIf="!(this.params['type'] && !params['type'].includes('specials'))" class="row searchrow">
            </div>
            <div *ngIf="this.params['type'] && !params['type'].includes('specials')" class="row searchrow">
                <input [ngClass]="{'lower-search' : (Site?.NumberOfNewStock > 0 && Site)}" class="col-12 col-md-9 search" formControlName="search" (focus)="searchfocus(true)"
                    (blur)="searchfocus(false)" type="text" placeholder="Search.." (keydown.enter)="search(); searchTextBox.blur()" #searchTextBox>
                <p class="col-12 col-md-2 results">Page {{this.params['page']}} of {{this.pagecount}}. {{this.count}} Results.
                </p>
                <ul class="col-12" *ngIf="searchShowing">

                    <li *ngIf="this.BodyTypes.length > 0 && filteredBodytypes().length > 0 && this.params['type'] && !this.params['type'].includes('specials')">
                        <h5>Body Types</h5>
                        <p *ngFor="let type of filteredBodytypes()"><a
                                (click)="addparam('bodytype',type.VehicleTypeID_PK)">{{type.Name}}</a></p>
                        <br>
                    </li>

                    <li *ngIf="this.FuelTypes.length > 0 && filteredFueltypes().length > 0 && this.params['type'] && !this.params['type'].includes('specials')">
                        <h5>Fuel Types</h5>
                        <p *ngFor="let type of filteredFueltypes()"><a
                                (click)="addparam('fueltype',type.VehicleFuelTypeID_PK)">{{type.Name}}</a></p><br>
                    </li>
                    <li *ngIf="this.GearTypes.length > 0 && filteredGeartypes().length > 0 && this.params['type'] !== 'specials'">
                        <h5>Gear Types</h5>
                        <p *ngFor="let type of filteredGeartypes()"><a
                                (click)="addparam('geartype',type.VehicleTransmissionID_PK)">{{type.Name}}</a></p><br>
                    </li>
                    <li *ngIf="this.Regions.length > 0 && filteredRegions().length > 0">
                        <h5>Region</h5>
                        <p *ngFor="let type of filteredRegions()"><a
                                (click)="addparam('region',type.RegionID_PK)">{{type.Name}}</a></p><br>
                    </li>
                    <li *ngIf="this.Makes.length > 0 && filteredMakes().length > 0">
                        <h5>Makes</h5>
                        <p *ngFor="let series of filteredMakes()"><a
                                (click)="addparam('make',series.VehicleMakeID_PK)">{{series.Name}}</a></p><br>
                    </li>
                    <li *ngIf="this.Series.length > 0 && filteredSeries().length > 0">
                        <h5>Series</h5>
                        <p *ngFor="let series of filteredSeries()"><a

                                (click)="addparam('series',series.VehicleSeriesID_PK || series.VehicleSeriesID_FK)">{{series.Name}}</a></p><br>

                    </li>
                    <li *ngIf="this.Dealerships.length > 0 && filteredDealerships().length > 0">
                        <h5>Dealership</h5>
                        <p *ngFor="let series of filteredDealerships()"><a
                                (click)="addparam('dealership',series.DealershipID_PK)">{{series.Name}}</a></p><br>
                    </li>
                    <!--<li>
                        <h5>Type</h5>
                        <p *ngFor="let type of filteredTypes()"><a
                            (click)="addparam('type',type.Val)">{{type.Name}}</a></p><br>
                    </li>-->
                </ul>
            </div>

            <div class="row content">
                <div class="loader" *ngIf="this.loading">
                    <p>Your selection is loading. Please Wait.</p>
                </div>
                <div class="col-12 col-xl-3 col-lg-4 col-md-6 item" *ngFor="let v of Models">
                    <div *ngIf="v.type == 'NewModel'" class="card">
                        <!-- <div class="image card-img-top" [ngClass]="IsAlternativeDetails ? 'image-align-center' : ''">
                            <p *ngIf="v.InStock > 0" class="listings">{{v.InStock}} Dealer Stock</p>
                            <img loading="lazy" *ngIf="v.Images == null || !v.Images[0]" src="{{Site.vehicleImages.Value}}" alt="">

                            <app-slider [id]="'new'+(v.VehicleModelID_PK||v.VehicleID)" [activeIndex]="0" customURL="buy/new/{{v.VehicleModelID_PK||v.VehicleID}}/{{urlsan(v.ModelDescription)}}"
                                [autoScroll]="false" [images]="v.Images" [carouselStyling]="'custom-control'" *ngIf="v.Images!==null"></app-slider>
                            <div style="
                                border-top: lightgray solid 1px;
                                margin: 0 15px;"></div>
                        </div> -->
                        <a class="image card-img-top" [ngClass]="IsAlternativeDetails ? 'image-align-center' : ''" (mouseenter)="prefetchData('new',v.VehicleModelID_PK||v.VehicleID)"
                            href="buy/new/{{v.VehicleModelID_PK||v.VehicleID}}/{{urlsan(v.ModelDescription)}}">
                            <p *ngIf="v.InStock > 0" class="listings">{{v.InStock}} Dealer Stock</p>
                            <img loading="lazy" *ngIf="v.Images == null || !v.Images[0]" src="{{Site.vehicleImages.Value}}" alt="{{v.ModelDescription}}">

                            <app-slider [id]="'new'+(v.VehicleModelID_PK||v.VehicleID)" [activeIndex]="0"
                                [autoScroll]="false" [images]="v.Images" [carouselStyling]="'custom-control'" *ngIf="v.Images!==null"></app-slider>
                            <div style="
                                border-top: lightgray solid 1px;
                                margin: 0 15px;"></div>
                        </a>
                        <div class="card-body" *ngIf="!fullsizemodelimage">
                            <div class="bodyblock">
                                <div class="row name">
                                    <h6>{{v.ModelDescription}}</h6><button [ngClass]="isfav(v,'new')?'selected':''"
                                        (click)="fav(v.VehicleModelID_PK||v.VehicleID,'new')"><span
                                            class="icon-favourite"></span></button>
                                </div>
                                <div class="bodyrow">
                                    <div class="row pricerow">
                                        <div class="col-6" style="line-height:10px">
                                            <h5 class="d-inline" *ngIf="v.NewVehiclePrice||v.Price">{{this.currency}}{{v.NewVehiclePrice||v.Price | number:'1.0-0'}}</h5>
                                            <h5 class="col-6" *ngIf="!(v.NewVehiclePrice||v.Price)">POA</h5>
                                            <!-- <span *ngIf="VehicleMakeTypeExcludeVAT.length > 0 && VatExclusive(v.VehicleType, v.VehicleMake)" style="white-space: nowrap;font-size: clamp(10px, calc(0.6vw* 1.2), 13px);color: initial;"> Ex VAT</span> -->
                                            <span *ngIf="(v.NewVehiclePrice||v.Price) && VehicleMakeTypeExcludeVAT.length > 0 && VatExclusive(v.VehicleType, v.VehicleMake)"  class="priceMonthly"> Ex VAT</span>
                                        </div>
                                        <a *ngIf="!hideFinance && (v.NewVehiclePrice||v.Price) && (v.VehicleType != 'Commercial')" class="col-6" (click)="finance(v.NewVehiclePrice||v.Price, this.currency)">
                                            <p class="priceMonthly">From {{this.currency}}{{monthlyPayment(v.NewVehiclePrice||v.Price)| number:'1.0-0'}} pm
                                            </p>
                                        </a>
                                    </div>
                                    <p class="details">{{v.VehicleTransmission||''}} | {{v.FuelType}} | New </p>
                                    <p>Any {{Site?.container?.Name}} Dealer </p>
                                </div>
                            </div>
                        </div>
                        <div class="card-footer">
                            <div class="row">
                                <div class="col-xs-10 col-xs-offset-1">
                                    <button class="col-4 btn-tertiary p-1"
                                        (click)="href('buy/new/'+(v.VehicleModelID_PK||v.VehicleID)+'/'+(urlsan(v.ModelDescription)))"><span
                                            class="icon-info"></span> Info</button>
                                    <button (click)="enquire(v)" class="col-4 btn-primary p-1">Enquire</button>
                                    <a *ngIf="Site.dealerSite" class="call" href="tel:{{Site.dealership.PhoneNumber}}"><span
                                        class="icon-phone"></span></a>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div *ngIf="(v.VehicleStockType||v.Type) == 'New' || (v.VehicleStockType||v.Type) == 'Pre-Owned' || (v.VehicleStockType||v.Type) == 'Demo'" class="card">
                        <!-- <div class="image card-img-top" [ngClass]="IsAlternativeDetails ? 'image-align-center' : ''">
                            <p *ngIf="v.DaysInStock > 44 && ShowClearance" class="listings">Clearance Sale</p>
                            <img *ngIf="v.InstavidSpinID" class="instavidimg" src="assets/360img.png" alt=""/>
                            <img loading="lazy" *ngIf="v.Images == null || !v.Images[0]" src="{{Site.vehicleImages.Value}}" alt=""/>
                            <app-slider [id]="'stock'+(v.VehicleStockID_PK||v.VehicleID)" [activeIndex]="0" customURL="buy/{{((v.VehicleStockType||v.Type) == 'Pre-Owned' || (v.VehicleStockType||v.Type) == 'Demo' || (v.VehicleStockType||v.Type) == 'New')?'stock':(v.VehicleStockType||v.Type) | lowercase}}/{{v.VehicleStockID_PK||v.VehicleID}}/{{urlsan(v.WebFriendlyName||v.ModelDescription)}}"
                                [autoScroll]="false" [images]="v.Images" [carouselStyling]="'custom-control'" *ngIf="v.Images!==null"></app-slider>
                            <div style="border-top: lightgray solid 1px;
                                margin: 0 15px;">
                            </div>
                        </div> -->
                        <a class="image card-img-top" [ngClass]="IsAlternativeDetails ? 'image-align-center' : ''" (mouseenter)="prefetchData('stock',v.VehicleStockID_PK||v.VehicleID)"
                            href="buy/{{((v.VehicleStockType||v.Type) == 'Pre-Owned' || (v.VehicleStockType||v.Type) == 'Demo' || (v.VehicleStockType||v.Type) == 'New')?'stock':(v.VehicleStockType||v.Type) | lowercase}}/{{v.VehicleStockID_PK||v.VehicleID}}/{{urlsan(v.WebFriendlyName||v.ModelDescription)}}">
                            <p *ngIf="v.DaysInStock > 44 && ShowClearance && v.CampaignVehicle == 0" class="listings">Clearance Sale</p>
                            <img *ngIf="v.CampaignVehicle == 1" class="CampaignImg" src="assets/CampaignImage.png" alt="Miss It Miss Out Campaign"/>
                            <img *ngIf="v.InstavidSpinID" class="instavidimg" src="assets/360img.png" alt="360 degree viewing available"/>
                            <img loading="lazy" *ngIf="v.Images == null || !v.Images[0]" src="{{Site.vehicleImages.Value}}" alt="{{v.ModelDescription}}"/>
                            <app-slider [id]="'stock'+(v.VehicleStockID_PK||v.VehicleID)" [activeIndex]="0"
                                [autoScroll]="false" [images]="v.Images" [carouselStyling]="'custom-control'" *ngIf="v.Images!==null"></app-slider>
                            <div style="
                                border-top: lightgray solid 1px;
                                margin: 0 15px;"></div>
                        </a>
                        <div class="card-body">
                            <div class="bodyblock">
                                <div class="row name">
                                    <h6>{{v.ModelYear}} {{v.WebFriendlyName||v.ModelDescription}}</h6><button
                                        [ngClass]="isfav(v,'stock')?'selected':''"
                                        (click)="fav(v.VehicleStockID_PK||v.VehicleID,'stock')"><span
                                            class="icon-favourite"></span></button>
                                </div>
                                <div class="row pricerow">
                                    <h5 class="col-6">{{this.currency}}{{v.RetailPriceIncl||v.Price | number:'1.0-0'}}</h5>
                                    <a *ngIf="!hideFinance" class="col-6" (click)="finance(v.RetailPriceIncl||v.Price, this.currency)">
                                        <p class="priceMonthly">From {{this.currency}}{{monthlyPayment(v.RetailPriceIncl||v.Price)| number:'1.0-0'}} pm</p>
                                    </a>
                                </div>
                                <p class="details">{{v.OdoMeterReading| number:'1.0-0'}}kms | {{v.VehicleTransmission}}
                                    | {{v.VehicleFuelType||v.FuelType}} | {{v.VehicleStockType||v.Type}} </p>
                                <p class="dealerdetails">{{v.DealershipName}} </p>
                            </div>
                        </div>
                        <div class="card-footer">
                            <div class="row">
                                <div class="col-xs-10 col-xs-offset-1">
                                    <button class="col-4 btn-tertiary p-1"
                                        (click)="href('buy/'+(((v.VehicleStockType||v.Type) == 'Pre-Owned' || (v.VehicleStockType||v.Type) == 'Demo' || (v.VehicleStockType||v.Type) == 'New')?'stock':(v.VehicleStockType.toLowerCase( )||v.Type.toLowerCase( )))+'/'+(v.VehicleStockID_PK||v.VehicleID)+'/'+urlsan((v.WebFriendlyName||v.ModelDescription)))"><span
                                            class="icon-info"></span> Info</button>
                                    <button (click)="enquire(v)" class="col-4 btn-primary p-1">Enquire</button>
                                    <a class="call" href="tel:{{v.DealershipPhoneNumber}}"><span
                                            class="icon-phone"></span></a>
                                </div>
                            </div>

                        </div>
                    </div>
                    <div *ngIf="v.type == 'special'" class="card">
                        <ng-container *ngIf="v.Image !== null">
                            <a class="image card-img-top" [ngClass]="IsAlternativeDetails ? 'image-align-center' : ''" href="buy/special/{{v.SpecialID_PK}}/{{urlsan(v.Caption)}}"><img loading="lazy"
                                     src="{{v.Image}}" alt="{{v.Caption}}">
                                <img loading="lazy" *ngIf="v.Image == null" src="{{Site.vehicleImages.Value}}" alt="{{v.Caption}}">
                                <div style="
                                    border-top: lightgray solid 1px;
                                    margin: 0 15px;">
                                </div>
                            </a>
                        </ng-container>
                        <div class="card-body"></div>
                        <div class="card-footer">
                            <div class="row">
                                <div class="col-xs-10 col-xs-offset-1">
                                    <button class="col-4 btn-tertiary p-1"
                                        (click)="href('buy/special/'+v.SpecialID_PK+'/'+urlsan(v.Caption))"><span
                                            class="icon-info"></span> Info</button>
                                    <button (click)="enquire(v)" class="col-4 btn-primary p-1">Enquire</button>
                                    <a *ngIf="v.DealershipPhoneNumber && !v.GroupSpecial" class="call"
                                        href="tel:{{v.DealershipPhoneNumber}}"><span class="icon-phone"></span></a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row">
                <p class="pages">Page {{this.params['page']}} of {{this.pagecount}}. {{this.count}} Results.</p>
            </div>
            <div class="paging">

                <button class=" btn-primary" [disabled]="this.params['page'] == '1' || this.loading"
                    (click)="firstpage()">
                    << </button>
                        <button class=" btn-tertiary" [disabled]="this.params['page'] == '1' || this.loading"
                            (click)="prevpage()">
                            < Back</button>
                                <button class=" btn-tertiary"
                                    [disabled]="this.params['page'] == this.pagecount || this.loading"
                                    (click)="nextpage()">
                                    More ></button>
                                <button class=" btn-primary"
                                    [disabled]="this.params['page'] == this.pagecount || this.loading"
                                    (click)="lastpage()">>></button>

            </div>
        </div>

    </div>
    <div class="offcanvas offcanvas-end" tabindex="-1" id="offcanvasFilters" aria-labelledby="offcanvasFiltersLabel">
        <div class="offcanvas-header">
            <h5 class="offcanvas-title" id="offcanvasFiltersLabel">All Filters</h5>
            <button type="button" class="btn-close text-reset" data-bs-dismiss="offcanvas" aria-label="Close"></button>
        </div>
        <div class="offcanvas-body">
            <div id="accordionFiltersMobile" class="accordion">
                <div class="col-12 ">
                    <div *ngIf="this.params['type'] && this.params['type'].includes('specials')" class="accordion-item">
                        <h2 class="accordion-header" id="headingSpecialType">
                            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                                data-bs-target="#collapseSpecialType" aria-expanded="false" aria-controls="collapseOne">
                                Special Type
                            </button>
                        </h2>
                        <div id="collapseSpecialType" class="accordion-collapse collapse" aria-labelledby="headingSpecialType"
                            data-bs-parent="#accordionFilters">
                            <div class="accordion-body">
                                <div class="selectbox">
    
                                    <p>Special Type</p> <select [ngModel]="params['specialType']||'-1'"
                                        (change)="select('specialType',$event)" formControlName="specialType">
                                        <option *ngIf="SpecialSelectionLayout" value="-1" selected>All Specials</option>
                                        <option *ngFor="let specialType of this.SpecialsCategories" value="{{specialType.SpecialCategoryID_PK}}">
                                            {{specialType.Name}}</option>
                                    </select>
                                </div>
    
                            </div>
                        </div>
                    </div>
                    <div class="accordion-item" *ngIf="!Truck">
                        <h2 class="accordion-header" id="headingMakes">
                            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                                data-bs-target="#collapseMakes" aria-expanded="false" aria-controls="collapseOne">
                                <div *ngIf="this.params['type'] != 'new' && this.params['type'] != 'commercials' && this.params['type'] != 'newstock'">Makes &&nbsp;</div><div>Series</div>
                            </button>
                        </h2>
                        <div id="collapseMakes" class="accordion-collapse collapse" aria-labelledby="headingMakes"
                            data-bs-parent="#accordionFiltersMobile">
                            <div class="accordion-body">
                                <div *ngIf="this.params['type'] != 'new' && this.params['type'] != 'commercials' && this.params['type'] != 'newstock'" class="selectbox">

                                    <p>Makes</p>
                                    <select [ngModel]="params['make']||'-1'" (change)="makeselect($event)"
                                        formControlName="make">
                                        <option value="-1" selected>All Makes</option>
                                        <option *ngFor="let make of this.Makes" value="{{make.VehicleMakeID_PK}}">
                                            {{make.Name.toUpperCase()}}</option>
                                    </select>
                                </div>
                                <div class="selectbox">

                                    <p>Series</p>
                                    <select [ngModel]="params['series']||'-1'" (change)="select('series',$event)"
                                        formControlName="series">
                                        <option value="-1" selected>All Series</option>
                                        <option *ngFor="let series of this.Series" value="{{series.VehicleSeriesID_PK || series.VehicleSeriesID_FK}}">
                                            {{series.Name.toUpperCase()}}</option>
                                    </select>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="accordion-item" *ngIf="Truck">
                        <h2 class="accordion-header" id="headingSizes">
                            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                                data-bs-target="#collapseSizes" aria-expanded="false" aria-controls="collapseOne">
                                Size
                            </button>
                        </h2>
                        <div id="collapseSizes" class="accordion-collapse collapse" aria-labelledby="headingSizes"
                            data-bs-parent="#accordionFiltersMobile">
                            <div class="accordion-body">
                                <div class="selectbox">
                                    <p>Sizes</p>
                                    <select [ngModel]="params['sizes']||''" (change)="select('sizes',$event)"
                                        formControlName="sizes">
                                        <option value="" selected>All Sizes</option>
                                        <option *ngFor="let sizes of this.Sizes" value="{{sizes.name}}">
                                            {{sizes.text}}</option>
                                    </select>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="accordion-item" *ngIf="Truck">
                        <h2 class="accordion-header" id="headingRanges">
                            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                                data-bs-target="#collapseRanges" aria-expanded="false" aria-controls="collapseOne">
                                Range
                            </button>
                        </h2>
                        <div id="collapseRanges" class="accordion-collapse collapse" aria-labelledby="headingRanges"
                            data-bs-parent="#accordionFiltersMobile">
                            <div class="accordion-body">
                                <div class="selectbox">
                                    <p>Ranges</p>
                                    <select [ngModel]="params['range']||''" (change)="select('range',$event)"
                                    formControlName="range">
                                        <option value="" selected>All Ranges</option>
                                        <option *ngFor="let range of this.Range" value="{{range.name}}">
                                            {{range.text}}</option>
                                    </select>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="accordion-item"
                        *ngIf="this.params['type'] != 'new' && this.params['type'] != 'commercials' && this.params['type'] != 'newstock' && !this.params['type']?.includes('specials') && !Truck">
                        <h2 class="accordion-header" id="headingYears">
                            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                                data-bs-target="#collapseYears" aria-expanded="false" aria-controls="collapseOne">
                                Year
                            </button>
                        </h2>
                        <div id="collapseYears" class="accordion-collapse collapse" aria-labelledby="headingYears"
                            data-bs-parent="#accordionFiltersMobile">
                            <div class="accordion-body">

                                <div class="selectbox">

                                    <p>Year From</p>
                                    <select [ngModel]="params['yearmin']||'-1'" (change)="select('yearmin',$event)"
                                        formControlName="yearmin">
                                        <option value="-1" selected>10+ Years Old</option>
                                        <option *ngFor="let year of this.ModelYears" value="{{year.ModelYear}}">
                                            {{year.ModelYear}}</option>
                                    </select>
                                </div>
                                <div class="selectbox">

                                    <p>Year To</p>
                                    <select [ngModel]="params['yearmax']||'-1'" (change)="select('yearmax',$event)"
                                        formControlName="yearmax">
                                        <option value="-1" selected>Current Year</option>
                                        <option *ngFor="let year of this.ModelYears" value="{{year.ModelYear}}">
                                            {{year.ModelYear}}</option>
                                    </select>    
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="accordion-item" *ngIf="!this.params['type']?.includes('specials') && !Truck">
                        <h2 class="accordion-header" id="headingPrice">
                            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                                data-bs-target="#collapsePrice" aria-expanded="false" aria-controls="collapseOne">
                                Price
                            </button>
                        </h2>
                        <div id="collapsePrice" class="accordion-collapse collapse" aria-labelledby="headingPrice"
                            data-bs-parent="#accordionFiltersMobile">
                            <div class="accordion-body">
                                <div class="selectbox">

                                    <p>From Price</p><input [ngModel]="params['pricemin']||undefined"
                                        (change)="select('pricemin',$event)" formControlName="pricemin" type="number"
                                        placeholder="{{this.currency}}0">
                                </div>

                                <div class="selectbox">

                                    <p>To Price</p><input [ngModel]="params['pricemax']||undefined"
                                        (change)="select('pricemax',$event)" formControlName="pricemax" type="number"
                                        placeholder="{{this.currency}}1,000,000+">
                                </div>

                            </div>
                        </div>
                    </div>
                    <div class="accordion-item"
                        *ngIf="this.params['type'] != 'new' && this.params['type'] != 'commercials' && this.params['type'] != 'newstock' && !this.params['type']?.includes('specials') && !Truck">
                        <h2 class="accordion-header" id="headingKilometres">
                            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                                data-bs-target="#collapseKilometres" aria-expanded="false" aria-controls="collapseOne">
                                Kilometre
                            </button>
                        </h2>
                        <div id="collapseKilometres" class="accordion-collapse collapse"
                            aria-labelledby="headingKilometres" data-bs-parent="#accordionFiltersMobile">
                            <div class="accordion-body">
                                <div class="selectbox">

                                    <p>From Kilometre</p> <input [ngModel]="params['kilomin']||undefined"
                                        (change)="select('kilomin',$event)" formControlName="kilomin" type="number"
                                        placeholder="Min Kilometres">
                                </div>

                                <div class="selectbox">

                                    <p>To Kilometre</p><input [ngModel]="params['kilomax']||undefined"
                                        (change)="select('kilomax',$event)" formControlName="kilomax" type="number"
                                        placeholder="Max Kilometres">
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="accordion-item" *ngIf="!Truck">
                        <h2 class="accordion-header" id="headingRegions">
                            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                                data-bs-target="#collapseRegions" aria-expanded="false" aria-controls="collapseOne">
                                Region
                            </button>
                        </h2>
                        <div id="collapseRegions" class="accordion-collapse collapse" aria-labelledby="headingRegions"
                            data-bs-parent="#accordionFiltersMobile">
                            <div class="accordion-body">
                                <div class="selectbox">

                                    <p>Region</p> <select [ngModel]="params['region']||'-1'"
                                        (change)="select('region',$event)" formControlName="region">
                                        <option value="-1" selected>All Regions</option>
                                        <option *ngFor="let region of this.Regions" value="{{region.RegionID_PK}}">
                                            {{region.Name}}</option>
                                    </select>
                                </div>

                            </div>
                        </div>
                    </div>
                    <div class="accordion-item" *ngIf="!Truck">
                        <h2 class="accordion-header" id="headingDealers">
                            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                                data-bs-target="#collapseDealers" aria-expanded="false" aria-controls="collapseDealers">
                                Dealership
                            </button>
                        </h2>
                        <div id="collapseDealers" class="accordion-collapse collapse" aria-labelledby="headingDealers"
                            data-bs-parent="#accordionFiltersMobile">
                            <div class="accordion-body">
                                <div class="selectbox">

                                    <p>Dealership</p> <select [ngModel]="params['dealership']||'-1'"
                                    (change)="select('dealership',$event)" formControlName="dealership">
                                    <option value="-1" selected>All Dealerships</option>
                                    <optgroup *ngFor="let region of Regions" label="{{region.Name}}">
                                        <option *ngFor="let dealer of regionDealers(region.Name)"
                                            value="{{dealer.DealershipID_PK}}">
                                            {{dealer.Name}}</option>

                                    </optgroup>
                                </select>
                                </div>

                            </div>
                        </div>
                    </div>
                    <div class="accordion-item" *ngIf="!this.params['type']?.includes('specials')">
                        <h2 class="accordion-header" id="headingMore">
                            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                                data-bs-target="#collapseMore" aria-expanded="false" aria-controls="collapseMore">
                                More
                            </button>
                        </h2>
                        <div id="collapseMore" class="accordion-collapse collapse" aria-labelledby="headingMore"
                            data-bs-parent="#accordionFiltersMobile">
                            <div class="accordion-body">
                                <div class="selectbox" *ngIf="!Truck">

                                    <p>Fuel Type</p> <select [ngModel]="params['fueltype']||'-1'"
                                        (change)="select('fueltype',$event)" formControlName="fueltype">
                                        <option value="-1" selected>All Fuel Types</option>
                                        <option *ngFor="let fueltype of this.FuelTypes"
                                            value="{{fueltype.VehicleFuelTypeID_PK}}">{{fueltype.Name}}</option>
                                    </select>
                                </div>
                                <div class="selectbox">

                                    <p>Gear Type</p><select [ngModel]="params['geartype']||'-1'"
                                        (change)="select('geartype',$event)" formControlName="geartype">
                                        <option value="-1" selected>All Gear Types</option>
                                        <option *ngFor="let geartype of this.GearTypes"
                                            value="{{geartype.VehicleTransmissionID_PK}}">{{geartype.Name}}</option>
                                    </select>
                                </div>
                                <div class="selectbox" *ngIf="!Truck && !hideBodyTypeFilter && this.BodyTypes.length > 1">

                                    <p>Body Type</p> <select [ngModel]="params['bodytype']||'-1'"
                                        (change)="select('bodytype',$event)" formControlName="bodytype">
                                        <option value="-1" selected>All Body Types</option>
                                        <option *ngFor="let bodytype of this.BodyTypes"
                                            value="{{bodytype.VehicleTypeID_PK}}">
                                            {{bodytype.Name}}</option>
                                    </select>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="accordion-item">
                        <h2 class="accordion-header" id="headingSort">
                            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                                data-bs-target="#collapseSort" aria-expanded="false" aria-controls="collapseSort">
                                Sort by
                            </button>
                        </h2>
                        <div id="collapseSort" class="accordion-collapse collapse" aria-labelledby="headingSort"
                            data-bs-parent="#accordionFiltersMobile">
                            <div class="accordion-body">
                                <div class="selectbox">

                                    <p>Sort By</p> <select [ngModel]="params['sort']" (change)="select('sort',$event)"
                                        formControlName="sort">
                                        <option *ngFor="let sort of this.Sorts" value="{{sort.Value}}">{{sort.Name}}
                                        </option>
                                    </select>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
                <div>
                    <button type="button" class="btn-primary" data-bs-dismiss="offcanvas"
                        aria-label="Search">Search</button>
                    <button type="button" (click)="clear()" data-bs-dismiss="offcanvas"
                        class="btn-secondary">Clear</button>
                    <!--<button class="btn-secondary">Search</button>-->
                </div>
            </div>
        </div>
    </div>
</form>
<div class="offcanvas offcanvas-end" tabindex="-1" id="offcanvasSort" aria-labelledby="offcanvasSortLabel">
    <div class="offcanvas-header">
        <h5 class="offcanvas-title" id="offcanvasSortLabel">Sort</h5>
        <button type="button" class="btn-close text-reset" data-bs-dismiss="offcanvas" aria-label="Close"></button>
    </div>
    <div class="offcanvas-body">
        <div [ngClass]="params['sort'] == sort.Value?'selectedsort':''" *ngFor="let sort of Sorts">
            <a (click)="select('sort',sort.Value)" data-bs-dismiss="offcanvas">{{sort.Name}}</a>
        </div>
    </div>
</div>
